import React, { useEffect } from "react";
import { View, Animated, StyleSheet, Dimensions } from "react-native";
import { LinearGradient } from "expo-linear-gradient";

const { width } = Dimensions.get("window");

const SkeletonItem = () => {
  const animatedValue = new Animated.Value(0);

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(animatedValue, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: true,
        }),
        Animated.timing(animatedValue, {
          toValue: 0,
          duration: 1000,
          useNativeDriver: true,
        }),
      ])
    ).start();
  }, []);

  const opacity = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [0.3, 0.7],
  });

  return (
    <View style={styles.container}>
      <Animated.View style={[styles.avatar, { opacity }]} />
      <View style={styles.contentContainer}>
        <Animated.View style={[styles.titleLine, { opacity }]} />
        <Animated.View style={[styles.subtitleLine, { opacity }]} />
      </View>
      <Animated.View style={[styles.endBlock, { opacity }]} />
    </View>
  );
};

export const StockSkeletonLoader = () => {
  return (
    <View style={styles.listContainer}>
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
      <SkeletonItem />
    </View>
  );
};

const styles = StyleSheet.create({
  listContainer: {
    flex: 1,
    width: "100%",
    paddingVertical: 10,
  },
  container: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#ffffff",
    padding: 12,
    marginVertical: 6,
    borderRadius: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.05,
    shadowRadius: 5,
    elevation: 2,
    marginHorizontal: 4,
  },
  avatar: {
    width: 50,
    height: 50,
    borderRadius: 8,
    backgroundColor: "#E2E8F0",
  },
  contentContainer: {
    flex: 1,
    marginLeft: 12,
    justifyContent: "space-around",
    height: 40,
  },
  titleLine: {
    width: "60%",
    height: 14,
    borderRadius: 4,
    backgroundColor: "#E2E8F0",
  },
  subtitleLine: {
    width: "40%",
    height: 12,
    borderRadius: 4,
    backgroundColor: "#E2E8F0",
  },
  endBlock: {
    width: 60,
    height: 40,
    borderRadius: 8,
    backgroundColor: "#E2E8F0",
  },
});
